/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dropdown } from "react-bootstrap";
import { customerService } from "../../services/customer.service";
import LogicContext from "../../Context/LogicContext";
import { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import {
  GetRecoilCorporateList,
  SetRecoilCorporateList,
} from "../../store/corporateAtom";
import { useLocation, useNavigate } from "react-router-dom";
import { corporateService } from "../../services/corporation.service";
import { IoMdRefresh } from "react-icons/io";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import Papa from "papaparse";   // ← Added for reliable CSV export
import StatusBadge from "../../generals/StatusBadge";

const columns = [
  {
    title: 'ID',
    key: 'Corporate_Id',
    dataIndex: 'Corporate_Id',
    className: "text-primary",
    sorter: (a, b) => (a?.Corporate_Id ?? '') - (b?.Corporate_Id ?? '')
  },
  {
    title: 'Corporate Name',
    dataIndex: 'Corporate_Name',
    className: "text-primary font-bold",
    sorter: (a, b) => (a?.Corporate_Name ?? '').localeCompare(b?.Corporate_Name ?? '')
  },
  {
    title: "Mobile",
    dataIndex: "Corporate_Contact_Person_Mobile",
    sorter: (a, b) => (a?.Corporate_Contact_Person_Mobile ?? '').localeCompare(b?.Corporate_Contact_Person_Mobile ?? '')
  },
  {
    title: "Email",
    dataIndex: "Corporate_Email_Address",
    sorter: (a, b) => (a?.Corporate_Email_Address ?? '').localeCompare(b?.Corporate_Email_Address ?? '')
  },
  {
    title: "Contact Person",
    dataIndex: "Corporate_Contact_Person",
    sorter: (a, b) => (a?.Corporate_Contact_Person ?? '').localeCompare(b?.Corporate_Contact_Person ?? '')
  },
  {
    title: "Number of officer",
    dataIndex: "Number_Of_Officer_Name",
    sorter: (a, b) => (a?.Number_Of_Officer_Name ?? '').localeCompare(b?.Number_Of_Officer_Name ?? '')
  },
  {
    title: 'Status',
    dataIndex: 'Corporate_Approval_Status_Name',
    sorter: (a, b) => (a?.Corporate_Approval_Status_Name ?? '').localeCompare(b?.Corporate_Approval_Status_Name ?? ''),
    render: (record, row) => <StatusBadge statusId={row?.Corporate_Approval_Status_Id} statusName={record} />,
  },
];

function CorporatePage() {
  const logicContext = useContext(LogicContext);
  const getRecoilCorporateData = GetRecoilCorporateList();
  const setRecoilCorporateData = SetRecoilCorporateList();
  const [tableList, setTableList] = useState([]);

  const navigate = useNavigate();
  const mountedRef = useRef(true);

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = "Corporate page";
    if (getRecoilCorporateData.Corporate_Info?.length) {
      setTableList(getRecoilCorporateData?.Corporate_Info);
    }
  }, [getRecoilCorporateData.Corporate_Info]);

  function refreshList() {
    corporateService.getCorporateListNoCache().then((response) => {
      if (response?.data?.Corporate_Info) {
        setRecoilCorporateData(response.data);
        setTableList(response?.data?.Corporate_Info);
      }
    });
  }

  function addNewCorporate() {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }

  function selectCustomer(selectionList) {
    // setCustomerSelect(selectionList)
  }

  function customFilter(value) {
    if (value === 100) {
      return setTableList(getRecoilCorporateData?.Corporate_Info);
    }
    const newList = getRecoilCorporateData?.Corporate_Info.filter(
      (data) => data?.Corporate_Type_Id === value
    );
    setTableList(newList);
  }

  function handleRowClick(corp) {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${corp?.Corporate_Id}`);
  }

  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: tableList.length,
  };

  // ====================== EXPORT CSV ======================
  const exportToCSV = () => {
    if (!tableList?.length) {
      logicContext.showToast("No data to export", "warning");
      return;
    }

    const headers = columns.map(col => col.title);
    const keys = columns.map(col => col.dataIndex);

    const dataForExport = tableList.map(row => {
      const obj = {};
      keys.forEach((key, i) => {
        obj[headers[i]] = row[key] ?? '';
      });
      return obj;
    });

    const csv = Papa.unparse(dataForExport, { header: true });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `corporate_list_${moment().format("YYYY-MM-DD_HHmmss")}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    logicContext.showToast("✅ CSV exported successfully!", "success");
  };
  // =======================================================

  return (
    <>
      <section className="w-full">
        <div className="bg-white px-4 py-3 flex flex-col md:flex-row md:items-center md:justify-between gap-4 shadow-sm rounded-md">
          
          {/* Left controls: Filter + Reload + Total */}
          <div className="flex items-center gap-3">
            <Dropdown>
              <Dropdown.Toggle
                className="bg-gray-200 text-gray-700 text-xs h-9 px-4 rounded-md font-medium hover:bg-gray-300"
                id="dropdown-basic"
              >
                FILTER BY
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {getRecoilCorporateData?.Corporate_Type?.map((type, i) => (
                  <Dropdown.Item
                    key={i}
                    onClick={() => customFilter(type?.Corporate_Type_Id)}
                  >
                    {type?.Corporate_Type_Name}
                  </Dropdown.Item>
                ))}
                <Dropdown.Item onClick={() => customFilter(100)}>All</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Tooltip title="Reload">
              <button
                onClick={refreshList}
                className="p-2 rounded-full hover:bg-gray-200 active:bg-gray-300"
              >
                <IoMdRefresh className="h-4 w-4 text-gray-600" />
              </button>
            </Tooltip>

            <Tooltip title="Total">
              <span className="px-3 py-1 text-sm font-semibold text-primary bg-gray-100 rounded-md">
                Total: {getRecoilCorporateData?.total}
              </span>
            </Tooltip>
          </div>

          {/* Middle controls: Active/Inactive/Delete */}
          {/* {customerSelect.length > 0 && ( ... )} */}

          {/* Right controls: EXPORT + ADD NEW */}
          <div className="flex items-center gap-3">
            <button
              onClick={exportToCSV}
              className="font-medium text-xs px-3 py-2 rounded-md border border-gray-300 hover:bg-gray-100 transition-colors"
            >
              EXPORT
            </button>

            <button
              onClick={addNewCorporate}
              className="bg-blue-600 text-white font-medium text-xs px-4 py-2 rounded-md hover:bg-blue-700"
            >
              ADD NEW
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="mt-5">
          <GeneralCustomTable
            tableHeadList={columns}
            tableDataList={tableList}
            allowCheckBox={false}
            setSelectedRows={selectCustomer}
            paginationOptions={paginationOptions}
            rowKey={(record) => record.Corporate_Id}
            handleRowClick={handleRowClick}
          />
        </div>
      </section>
    </>
  );
}

export default CorporatePage;